/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useAuth } from "../modules/auth/components/AuthInit";
import { LotteryResultListing } from "../modules/lottery/component/lotteryResult/LotteryResultListing";
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

const AppRoutes = () => {
  const { auth } = useAuth();

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route
          path="/*"
          element={<LotteryResultListing isResultOnly={true} />}
        />
        <Route
          path="*"
          element={<LotteryResultListing isResultOnly={true} />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
